import PropTypes from "prop-types";
import React from "react";

const QrGlyph = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <rect x="2" y="2" width="14" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="5" y="5" width="8" height="8" fill="currentColor" />
    <rect x="20" y="2" width="14" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="23" y="5" width="8" height="8" fill="currentColor" />
    <rect x="2" y="20" width="14" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="5" y="23" width="8" height="8" fill="currentColor" />
    <rect x="20" y="20" width="4" height="4" fill="currentColor" />
    <rect x="20" y="26" width="4" height="4" fill="currentColor" />
    <rect x="26" y="20" width="4" height="4" fill="currentColor" />
    <rect x="26" y="26" width="4" height="4" fill="currentColor" />
    <rect x="32" y="20" width="4" height="4" fill="currentColor" />
    <rect x="32" y="26" width="4" height="4" fill="currentColor" />
  </svg>
);

QrGlyph.propTypes = { size: PropTypes.number };

export default QrGlyph;
